import React from 'react';
import type { HealthResult, MiradorClientItem } from '../../services/adminMiradorService';

interface Props {
  tenant: MiradorClientItem;
  health: HealthResult | undefined;
}

export const ClientHealthCard: React.FC<Props> = ({ tenant, health }) => {
  const ok = health?.ok;
  const dotClass = ok === undefined
    ? 'bg-gray-400'
    : ok
    ? 'bg-emerald-500'
    : 'bg-red-500';
  const statusLabel = ok === undefined ? 'En cours…' : ok ? 'Healthy' : 'Down';

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
      <div className="flex items-start justify-between gap-2 mb-2">
        <div>
          <div className="font-semibold text-gray-900">{tenant.name}</div>
          <div className="text-xs text-gray-500 font-mono">{tenant.slug}</div>
        </div>
        <div className="flex items-center gap-2">
          <span className={`inline-block w-2.5 h-2.5 rounded-full ${dotClass}`} />
          <span className={`text-xs font-medium ${ok === false ? 'text-red-600' : 'text-gray-700'}`}>
            {statusLabel}
          </span>
        </div>
      </div>

      {!tenant.enabled && (
        <div className="text-xs text-amber-700 mb-2">⚠ Config présente mais <code>enabled=false</code></div>
      )}

      {tenant.domains && Object.keys(tenant.domains).length > 0 && (
        <div className="text-xs text-gray-600 mb-2">
          Domaines :{' '}
          {Object.entries(tenant.domains).map(([code, e], i, arr) => (
            <span key={code}>
              <span className={e.enabled ? 'text-gray-900 font-medium' : 'text-gray-400 line-through'}>
                {code}
              </span>
              <span className="text-gray-400"> → {e.table_name}</span>
              {i < arr.length - 1 && <span className="text-gray-300"> · </span>}
            </span>
          ))}
        </div>
      )}

      <div className="text-xs text-gray-600 space-y-1">
        <div>
          Latence :{' '}
          <span className="font-medium text-gray-900">
            {health?.latency_ms != null ? `${health.latency_ms} ms` : '—'}
          </span>
        </div>
        <div>
          Dernier check :{' '}
          <span className="font-medium text-gray-900">
            {health?.last_checked_at
              ? new Date(health.last_checked_at).toLocaleTimeString('fr-CA')
              : '—'}
          </span>
        </div>
        {health?.error && (
          <div className="mt-2 text-red-700 break-words" title={health.error}>
            {health.error}
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientHealthCard;
